enum ReconciliationRoutes {
  Groups = '/reconciliation',
  Reconciliation = '/reconciliation/manufacturer/:manufacturer_id/retailer/:retailer_id',
}

export default ReconciliationRoutes
